import { Component } from "react";
import View from "./view";
import {
  getFormForTool,
  createToolInspection,
  getTool,
  getFaultyList,
} from "../../../backend/machines";
import withRouter from "react-router-dom/withRouter";
import { connect } from "react-redux";

class ToolForm extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      tool: props.tool,
      tool_id: props.match.params.tool_id,
      form_id: props.match.params.form_id,
      savedForm: Boolean(props.match.params.form_id),
      dialogVisible: false,
      loading: false,
      status: '',
      faulty_list: null
    };

    
    this._leave = this._leave.bind(this);
    this._valid = this._valid.bind(this);
    this._toggleSubmitDialog = this._toggleSubmitDialog.bind(this);
    this._editTool = this._editTool.bind(this);
  }

  async componentDidMount() {
    const { form_id, tool_id } = this.state;
    const faulty_list = await getFaultyList(0)
    const t_faulty_list = [];

    faulty_list.map(
        ({id,type, name}, key) => type === 'Tool' && (
            t_faulty_list.push({ key:key, value: id, label: name })
        )
    )
    
    if (form_id || tool_id) this.setState({ loading: true });

    if (form_id) {
      this.setState({ ...(await getFormForTool(form_id)), loading: false });
    }
    if (tool_id) {
      this.setState({ tool: await getTool(tool_id), loading: false, t_faulty_list: t_faulty_list, });
    }
  }

  _change(prop, ev = false, sel = false) {
    return event =>
      this.setState({
        [prop]: ev ? (sel ? event.value : event) : event.target.value
      });
  }

  _valid() {
    return (
      this.state.priority !== undefined &&
      this.state.tool_id !== undefined &&
      this.state.status !== undefined &&
      this.state.inspection_pass !== undefined &&
      this.state.inspection_note !== undefined &&
      this.state.require_swap !== undefined &&
      (this.state.require_swap === true
        ? this.state.one_way_swap !== undefined && (
          this.state.one_way_swap !== true ? this.state.new_tool_id !== undefined : true
        )
        : true)
    );
  }

  _leave(event) {
    this._toggleSubmitDialog();
  }

  _toggleSubmitDialog() {
    this.setState({ dialogVisible: !this.state.dialogVisible });
  }
  _editTool(index, inputType = "input", prop) {
    return event => {
      let value;
      if (inputType === "radio") {
        value = event;
      } else if (inputType === "select") {
        value = event.value;
      } else if (inputType === "input") {
        value = event.target.value;
      }

      let { tool } = this.state;
     
        if( prop === 'status'){
            this.setState({status : value});
        } else if (prop === 'faulty_reason'){
            let text = event.label;
            let other = event.label === 'Other' ? 1 : 0;
            tool = { ...tool,faulty_reason: { id : value, text: text, other: other } }
            this.setState({ tool });
        } else if (prop === 'faulty_reason_text'){
            // return faulty_reason.text = event.target.value
            tool = { ...tool,faulty_reason: { id: this.state.tool.faulty_reason.id, text: event.target.value, other:1 } }
            this.setState({ tool });
        }else{
            tool = { ...tool, hire_status: value };
            this.setState({ tool });
        }
    
    };
  }
  async _upload() {
    const {
      inspection_note,
      inspection_pass,
      require_swap,
      status,
      one_way_swap,
      new_tool_id,
      priority,
      tool,

    } = this.state;
    const { store_id } = this.state.tool;
    const { tool_id } = this.props.match.params;

    this.setState({ uploading: true });
    await createToolInspection({
      inspection_note,
      inspection_pass,
      require_swap,
      store_id,
      priority,
      one_way_swap,
      new_tool_id,
      status,
      tool_id,
      tool
    });
    this.setState({ uploading: false, savedForm: true });
    this.props.history.goBack();
    // this.props.history.push(`/machines/${store_id}`);
  }

  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }

  render() {
    return View.call(this);
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    tool: state.selections.tool 
  };
};

export default withRouter(connect(mapStateToProps)(ToolForm));



// WEBPACK FOOTER //
// ./src/screens/tools/tool-form/index.js